export default __webpack_public_path__ + "static/O0030-2cb185321496f7a8434445b43b14e673.png";